import { useContext } from "react"
import { DadosBancariosSubcontaContext } from "./DadosBancariosSubcontaContext"

export function useDadosBancariosSubcontaContext() {
    return useContext(DadosBancariosSubcontaContext)
}
